namespace RedBullMOBILE360.CustomerCare {
    export namespace UnBlockedSMSCustomersService {
        export const baseUrl = 'CustomerCare/UnBlockedSMSCustomers';

        export declare function Create(request: Serenity.SaveRequest<UnBlockedSMSCustomersRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<UnBlockedSMSCustomersRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<UnBlockedSMSCustomersRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<UnBlockedSMSCustomersRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "CustomerCare/UnBlockedSMSCustomers/Create",
            Update = "CustomerCare/UnBlockedSMSCustomers/Update",
            Delete = "CustomerCare/UnBlockedSMSCustomers/Delete",
            Retrieve = "CustomerCare/UnBlockedSMSCustomers/Retrieve",
            List = "CustomerCare/UnBlockedSMSCustomers/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>UnBlockedSMSCustomersService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
